import CaretSmallRight from "../../../../common/icons/CaretsSmallRight.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";
import styles from "./ResultCountButton.module.scss";

interface Props {
  onClick: () => void;
  count: number;
  title: string;
  libraryReturn: string;
}

export default function ResultCountButton({
  onClick,
  count,
  title,
  libraryReturn,
}: Props) {
  const intl = useIntl();

  return (
    <BaseLinkOrButton
      className={clsx("vst-link", "vst-link-size-small", styles.button)}
      onClick={onClick}
      aria-label={intl.formatMessage(
        {
          defaultMessage:
            "View {num, plural, =1 {1 Content Result} other {# Content Results}} for {title}",
        },
        { num: count, title: title }
      )}
      data-library-return={libraryReturn}
    >
      <FormattedMessage
        defaultMessage="{num, plural, =1 {1 Content Result} other {# Content Results}}"
        values={{ num: count }}
      />
      <CaretSmallRight />
    </BaseLinkOrButton>
  );
}
